import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'bfa-portfolio-selector',
	styleUrls: ['./portfolio-selector.component.scss'],
	templateUrl: './portfolio-selector.component.html'
})
export class PortfolioSelectorComponent implements OnInit {
	@Input() public portfolioData: any;
	@Input() public selectorType: string = 'tabs';
	@Input() public selectedPortfolioIndex: number = 0;
	@Input() public maxLength: number = 50;
	@Input() public useMaxLength: boolean = false;
	@Input() public hiddenIndexes: Array<number> = [];
	public displayIndexes: Array<number> = [];
	public buttonNames: Array<string> = [];
	@Output() public updateSelectedPortfolioIndex = new EventEmitter();

	public ngOnInit(): void {
		if (this.portfolioData) {
			this.setButtonNames();
			this.setDisplayIndexes();
		}
		this.setSelectedPortfolioCss(this.selectedPortfolioIndex);
		this.updateSelectedPortfolioIndex.emit(this.selectedPortfolioIndex);
	}

	/**
	 * @description setDisplayIndexes: if hiddenIndexes have been set, then we'll filter our indexes of which portfolios to display so
	 * that hidden indexes are not shown.
	 */
	public setDisplayIndexes(): void {
		this.buttonNames.forEach((button, index) => {
			if (this.hiddenIndexes.indexOf(index) === -1) {
				this.displayIndexes.push(index);
			}
		});
	}

	/**
	 * setSelectedPortfolioCss: sets the classes selected || deselected depending on the state of the button.
	 * @param {number } index the index of the portfolio.
	 */
	public setSelectedPortfolioCss(index: number): string {
		const buttonClass = this.setButtonClass(this.displayIndexes.length);
		const selected = index === this.selectedPortfolioIndex ? ' selected' : ' deselected';
		return buttonClass + selected;
	}

	/**
	 * selectPortfolio: sets the selected portfolio index.
	 * @param {number } index the index of the portfolio.
	 */
	public selectPortfolio(index: number): void {
		this.selectedPortfolioIndex = index;
		this.updateSelectedPortfolioIndex.emit(index);
	}

	/**
	 * setButtonClass: sets the grid col width class based on the number of portfolios.
	 * @param {number} total the total number of portfolios.
	 */
	public setButtonClass(total: number): string {
		switch (total) {
			case 2:
				return 'col-12';
			case 3:
				return 'col-8';
			case 4:
				return 'col-6';
			case 5:
				return 'col-one-fifth';
			default:
				return '';
		}
	}
	/**
	/**
	 * setButtonNames: sets the button names applying any max length constraints.
	 */
	private setButtonNames(): void {
		this.buttonNames = this.portfolioData.map(portfolio => {
			return portfolio.field['name'].formattedValue;
		});

		if (this.buttonNames.length && this.useMaxLength) {
			this.buttonNames = this.buttonNames.map(name => {
				if (name.length > this.maxLength) {
					return name.slice(0, this.maxLength) + '...';
				} else {
					return name;
				}
			});
		}
	}
}
